export const MODAL_SIZE = {
  LARGE: "large",
  MEDIUM: "medium",
  SMALL: "small",
};

export const MODAL_SIZE_CLASSES = {
  [MODAL_SIZE.LARGE]: "amer-pop--large",
  [MODAL_SIZE.MEDIUM]: "amer-pop--medium",
  [MODAL_SIZE.SMALL]: "amer-pop--small",
};

export const MODAL_MASK_STYLE = { backgroundColor: "rgba(15, 18, 49, 0.6)" };

export const FILTER_PILL_VARIANT = {
  PILLS: "pills",
  BOXED: "boxed",
};

export const USAGE_METER_THRESHOLD = {
  FULL: 100,
  NEAR: 80,
};

export const USAGE_METER_LEVEL = {
  FULL: "full",
  NEAR: "near",
  LOW: "low",
};

export const USAGE_METER_TONE = {
  NORMAL: "normal",
  INVERTED: "inverted",
};

export const USAGE_METER_STROKE_COLORS = {
  [USAGE_METER_TONE.NORMAL]: {
    [USAGE_METER_LEVEL.FULL]: "rgb(var(--color-danger))",
    [USAGE_METER_LEVEL.NEAR]: "rgb(var(--color-warning))",
    [USAGE_METER_LEVEL.LOW]: "rgb(var(--color-success))",
  },
  [USAGE_METER_TONE.INVERTED]: {
    [USAGE_METER_LEVEL.FULL]: "rgb(var(--color-success))",
    [USAGE_METER_LEVEL.NEAR]: "rgb(var(--color-primary))",
    [USAGE_METER_LEVEL.LOW]: "rgb(var(--color-warning))",
  },
};

export const USAGE_METER_TRAIL_COLOR = "var(--color-chart-track)";

export const CALENDAR_PILL_COLOR = {
  BLUE: "blue",
  WARNING: "warning",
  DANGER: "danger",
};

export const CALENDAR_PILL_COLOR_CLASSES = {
  [CALENDAR_PILL_COLOR.BLUE]: "bg-brand/10 text-brand hover:bg-brand/20",
  [CALENDAR_PILL_COLOR.WARNING]:
    "bg-warning/10 text-warning hover:bg-warning/20",
  [CALENDAR_PILL_COLOR.DANGER]: "bg-danger/10 text-danger hover:bg-danger/20",
};

export const CALENDAR_DEFAULT_TIME_SLOTS = [
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
];

/**
 * Tailwind's `display: none`, for a block kept mounted while another one shows —
 * a form behind a segmented switch, the steps of a stepped form — so it keeps
 * what was typed and AntD keeps validating its fields.
 */
export const HIDDEN_CLASS = "hidden";

/** `HIDDEN_CLASS` unless `visible`; nothing while it is. */
export const hiddenUnless = (visible) => (visible ? "" : HIDDEN_CLASS);

/**
 * The `styles` for the info-icon hint `Tooltip` beside a filter label or a search
 * box: narrow enough to wrap a sentence, in the filters' smaller type.
 */
export const HINT_TOOLTIP_STYLES = Object.freeze({
  root: { maxWidth: 280 },
  body: { fontSize: 12, lineHeight: "1.6" },
});

/**
 * The `styles` for a `Popover` whose content draws its own box (the profile
 * headers' "marketplace link" chip), so AntD adds no padding around it.
 */
export const FLUSH_POPOVER_STYLES = Object.freeze({ body: { padding: 0 } });

/**
 * The `styles` for a `Select` whose popup is unhooked from its width
 * (`popupMatchSelectWidth={false}`), so long option names stop at a readable
 * width instead of running across the page. AntD's replacement for `dropdownStyle`.
 */
export const NARROW_SELECT_POPUP_STYLES = Object.freeze({
  popup: { root: { maxWidth: 350 } },
});
